import { FormControl, Grid, Typography } from "@mui/material";
import { StyledFormLabel, ToggleSwitch } from "@components/Common";
import {
	horizontalFormControlGridLeftStyle,
	horizontalFormControlGridRightStyle,
	requiredLabelStyle,
} from "@styles/global-css-class";
import { IFormControlProperty } from "@definitions/index";
import { FieldError } from "@components/FieldError";
import { memo } from "react";

const ToggleFormControl = ({
	label,
	name,
	value,
	defaultValue,
	onChange,
	isRequired,
	isDisabled,
	isHidden,
	formState,
	xsFormControl = 12,
	mdFormControl = 12,
	xsLabel = 6,
	xsInput,
	textAlign,
	textErrorAlign,
	itemSx,
	textSx,
	...props
}: IFormControlProperty) => {

	return <Grid container item xs={xsFormControl} md={mdFormControl}>
		<FormControl fullWidth margin='dense' {...props}>
			<Grid container>
				<Grid item xs={xsLabel} sx={itemSx ?? horizontalFormControlGridLeftStyle}>
					<StyledFormLabel
						htmlFor={name}
						aria-describedby={name}
						hidden={isHidden}
						error={formState?.errors[name] !== undefined}
						sx={textSx ?? {
							...requiredLabelStyle,
							textAlign: textAlign ?? "right",
						}}>
						{label}
						{isRequired && (
							<Typography
								style={{
									color: "red",
									fontSize: "18px",
								}}>
								*
							</Typography>
						)}
					</StyledFormLabel>
				</Grid>
				<Grid
					item
					xs={xsInput ?? (xsLabel === 12 ? 12 : 12 - xsLabel)}
					sx={itemSx ?? horizontalFormControlGridRightStyle}>
					<ToggleSwitch
						id={name}
						name={name}
						hidden={isHidden}
						checked={value ?? defaultValue ?? false}
						disabled={isDisabled ?? false}
						onChange={(e: any, checked: boolean) => {
							onChange(checked);
						}}
					/>
				</Grid>
				{formState && <FieldError formState={formState} name={name} textAlign={textErrorAlign} />}
			</Grid>
		</FormControl>
	</Grid>;
};

export default memo(ToggleFormControl);
